<div class="page-heading">
  <div *ngIf="routerLinkText">
    <a *ngIf="isDefault" class="Body-Small---Link" href="javascript:history.back()">
      <i class="fal fa-fw fa-chevron-left prefix-icon back-link-icon"></i>
      <span>{{ routerLinkText }}</span>
    </a>
    <a *ngIf="!isDefault" class="Body-Small---Link" (click)="goBack()">
      <i class="fal fa-fw fa-chevron-left prefix-icon back-link-icon"></i>
      <span>{{ routerLinkText }}</span>
    </a>
  </div>
  <div class="page-heading__heading" *ngIf="heading">
    <h1>{{ heading }}</h1>
  </div>
</div>
